import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import { Message } from "../../../components/message";
import { useNavigate } from "react-router-dom";
import { Modal, Table } from "react-bootstrap";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";
import dataicon from "../../../../src/assets/images/data-icon.png";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DeleteIcon, EditIcon, EyeIcon } from "../AdminIcon";
import {
  applicationListCsv,
  applicationListExcel,
  applicationListPdf,
  deleteApplicationData,
  getallApplicationListSort,
  getApplicationListBystatus,
  getSubCategoriesDropdown,
} from "../../../services/api/admin";
import ReactPaginate from "react-paginate";
import { formatDateWithSlash, getDaysDifference, printData } from "../../../Utils/common";
import { stateDistrict } from "../../../services/api/auth";
import NotFoundTable from "../../../components/notFound/NotFoundTable";
import { PdfBaseUrl } from "../../../Utils/Utils";
import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { set } from "react-hook-form";
import TotalRecords from "../../../components/notFound/TotalRecords";

const CategoriesApplicationReport = () => {
  const appStatus = "4";
  const application_type = "0";
  const navigate = useNavigate();
  const [applicationList, setApplicationList] = useState([]);
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteData, setDeleteData] = useState();
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const [searchTerm, setSearchTerm] = useState();
  const [orderBy, setOrderBy] = useState("desc");
  const [sortBy, setSortBy] = useState("created_at");
  const [searchData, setSearchData] = useState("");
  const [tableDataLoaded, setTableDataLoaded] = useState(false);
  const [pdfDownLoading, setPdfDownLoading] = useState(false);
  const [showUnitFilter, setShowUnitFilter] = useState(false);
  const [unitNameSearch, setUnitNameSearch] = useState("");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [searchSubCategory, setSearchSubCategory] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchStatus, setSearchStatus] = useState();

  const applicationStatusList = [
    { value: "2", label: "Document Pending" },
    { value: "3", label: "Draft" },
    { value: "4", label: "Approved" },
    { value: "5", label: "Rejected" },
    { value: "6", label: "Expired" },
    { value: "7", label: "Under Review" },
    { value: "8", label: "Submitted" },
    { value: "10", label: "Withdrawal" },
    { value: "11", label: "Payment Document Rejected" },
    { value: "12", label: "Revised Policy Payment Due" },
  ];

  useEffect(() => {
    setSearchStatus(applicationStatusList.find((option) => option.value == "4"));
    getApplicationTableData("created_at", "1", "desc", "", "", "", applicationStatusList.find((option) => option.value == "4"));
    getSubCategoryList();
  }, []);

  const resetFilter = () => {
    setSearchSubCategory("");
    setSearchStatus("");
    getApplicationTableData(sortBy, 1, orderBy, searchData, unitNameSearch, "", "");
  };

  const getSubCategoryList = async () => {
    try {
      const subCategoryList = await getSubCategoriesDropdown();
      const data = subCategoryList?.data?.map((item) => ({
        value: item?.id,
        label: item?.category_name,
      }));
      setSubCategoryList(data);
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const getApplicationTableData = async (
    sortBy,
    pageNo,
    orderBy,
    searchBy,
    unitSearch,
    searchSubCategory,
    searchStatus 
  ) => {
    try {
      setSearchData(searchBy);
      setOrderBy(orderBy);
      setSortBy(sortBy);
      const totalapplicationData = await getallApplicationListSort(
        sortBy,
        orderBy,
        searchBy,
        searchStatus?.value ? searchStatus?.value : "",
        pageNo,
        unitSearch,
        application_type,
        searchSubCategory?.value ? searchSubCategory?.value : "",
        ""
      );
      if (totalapplicationData?.status == 200) {
        const data = totalapplicationData?.data?.data;
        setCurrentPage(pageNo > 0 ? pageNo - 1 : pageNo);
        setApplicationList(data);
        setTotalPages(
          Math.ceil(
            totalapplicationData?.data?.total /
              totalapplicationData?.data?.per_page
          )
        ); // Calculate total pages
        setTotalRecords(totalapplicationData?.data?.total);
      } else {
        setApplicationList([]);
        setApiMessage({
          type: "error",
          message: totalapplicationData?.message,
        });
      }
      setTableDataLoaded(true);
    } catch (err) {}
  };

  const handleUnitNameFilter = (value) => {
    setUnitNameSearch(value);
    getApplicationTableData(sortBy, currentPage, orderBy, searchData, value, searchSubCategory, searchStatus);
  };

  const handlePageChange = (selectedPage) => {
    getApplicationTableData(
      sortBy,
      selectedPage.selected + 1,
      orderBy,
      searchData,
      unitNameSearch,
      searchSubCategory,
      searchStatus
    );
  };

  const pdfDownload = async () => {
    try {
      setPdfDownLoading(true);
      const response = await applicationListPdf(searchStatus?.value ? searchStatus?.value : "", application_type, searchSubCategory?.value ? searchSubCategory?.value : "", "");
      setPdfDownLoading(false);
      window.open(
        `${PdfBaseUrl()}/${response.folder_path}/${response.file_name}`
      );
    } catch (err) {
      setPdfDownLoading(false);
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const excelDownload = async () => {
    try {
      const response = await applicationListExcel(searchStatus?.value ? searchStatus?.value : "", application_type, searchSubCategory?.value ? searchSubCategory?.value : "", "");
      window.open(response?.file_path);
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const csvDownload = async () => {
    try {
      const response = await applicationListCsv(searchSubCategory?.value ? searchSubCategory?.value : "", application_type);
      window.open(response?.file_path);
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const exportPrint = async () => {
    try {
      // Fetch the PDF URL from the API
      const response = await applicationListPdf(searchStatus?.value ? searchStatus?.value : "", application_type, searchSubCategory?.value ? searchSubCategory?.value : "", "");
      if (response) {
        printData(response);
      }
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const getRowBgColor = (updatedAt, status) => {
    if(status === "4") return "green";
    const diff = getDaysDifference(updatedAt);
    if (diff > 60) return "#da0808";
    if (diff >= 16) return "#FFC107";
    return "#ffffff";
  };

  const getTextColor = (updatedAt, status) => {
    const diff = getDaysDifference(updatedAt);
    return diff > 60 || status === "4" ? "text-white" : "";
  };

  return (
    <AdminDashboard>
      <div className="aod-outer">
        {apiMessage && (
          <Message
            apiMessage={apiMessage}
            setApiMessage={setApiMessage}
          ></Message>
        )}
        <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
          <div>
            <HomeIcon />
            <b onClick={() => navigate("/admin/")}>Home / </b>
            <span>Categories Applications Report</span>
          </div>
          <div className="dropdown download_file_dropdown ms-auto d-flex gap-2 mb-3 flex-wrap align-items-center">
            {pdfDownLoading ? (
              <a className=" px-2 btn btn-danger btn-sm">
                {" "}
                <i className="fa fa-file-pdf me-1"></i>
                <span>PDF</span>
                <Spinner
                  animation="border"
                  className="pdf-spinner"
                  role="status"
                  style={{ marginLeft: "5px" }}
                >
                  <span className="visually-hidden"></span>
                </Spinner>
              </a>
            ) : (
              <a
                className=" px-2 btn btn-danger btn-sm"
                onClick={() => pdfDownload()}
              >
                {" "}
                <i className="fa fa-file-pdf me-1"></i> PDF
              </a>
            )}
            <a
              className=" px-2 btn btn-success btn-sm"
              onClick={() => excelDownload()}
            >
              <i className="fa fa-file-excel  me-1"></i>
              Excel{" "}
            </a>
            {/* <a className=" px-2 btn btn-primary btn-sm" onClick={() => csvDownload()} ><i className="fa fa-file-csv  me-1"></i>
                            CSV</a> */}
            <a
              className=" px-2 btn btn-info  btn-sm"
              onClick={() => exportPrint()}
            >
              <i className="fa fa-print me-1"></i>
              Print
            </a>
          </div>
        </div>
        <div className="aod-inner pt-0">
          <div className="aod-bottom">
            <div className="adm-tabs-outer">
              <h4 className="mb-0 w-100">Categories Applications Report</h4>
              <div className="position-relative w-25">
                <input
                  className="px-2 form-control"
                  placeholder="Search"
                  type="text"
                  value={searchTerm} // Add a state for the input value
                  onChange={(e) => {
                    setSearchTerm(e.target.value); // Update the state
                    getApplicationTableData(
                      sortBy,
                      1,
                      orderBy,
                      e.target.value,
                      unitNameSearch,
                      searchSubCategory,
                      searchStatus
                    );
                  }}
                />
                {searchTerm && ( // Show the clear button only when there's text
                  <button
                    className="btn btn-clear position-absolute"
                    onClick={(e) => {
                      setSearchTerm(""); // Clear the input value
                      getApplicationTableData(
                        sortBy,
                        1,
                        orderBy,
                        "",
                        unitNameSearch,
                        searchSubCategory,
                        searchStatus
                      ); // Fetch data with empty search term
                    }}
                    style={{
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      border: "none",
                      background: "transparent",
                      fontSize: "1rem",
                      cursor: "pointer",
                    }}
                  >
                    &times; {/* This is the "X" icon */}
                  </button>
                )}
              </div>
            </div>
            <div className="aod-head"></div>
            <div className="row py-4">
              <div className="col-md-4 aod-resp-tab">
                <div className="suf-input-box aod-form-input mb-2">
                  <Select
                    className="menu_open_select w-100"
                    classNamePrefix="ad-menu_open_select_class"
                    aria-label="Default select example"
                    value={searchSubCategory}
                    options={subCategoryList}
                    onChange={(e) => {
                      setSearchSubCategory(e);
                      getApplicationTableData(sortBy, 1, orderBy, searchData, unitNameSearch, e, searchStatus);
                    }}
                    placeholder="Select Sub Category"
                  />
                </div>
              </div>
              <div className="col-md-4 aod-resp-tab">
                <div className="suf-input-box aod-form-input mb-2">
                  <Select
                    className="menu_open_select w-100"
                    classNamePrefix="ad-menu_open_select_class"
                    aria-label="Default select example"
                    value={searchStatus}
                    options={applicationStatusList}
                    onChange={(e) => {
                      setSearchStatus(e);
                      getApplicationTableData(sortBy, 1, orderBy, searchData, unitNameSearch, searchSubCategory, e);
                    }}
                    placeholder="Select Status"
                  />
                </div>
              </div>
              <div className="col-md-2">
                <button
                  onClick={resetFilter}
                  className="ad-reset-btn w-auto px-4"
                >
                  Reset
                </button>
              </div>
              <TotalRecords totalRecords={totalRecords}></TotalRecords>
            </div>
            <div className="ad-reg-table">
              <div className="ad-reg-table">
                <Table size="sm" className="ad-cat-table">
                  <thead>
                    <tr>
                      <th className="ad-sno">S. No</th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          getApplicationTableData(
                            "sub_category_name",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            unitNameSearch,
                            searchSubCategory,
                            searchStatus
                          )
                        }
                      >
                        Sub category{" "}
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          getApplicationTableData(
                            "district_name",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            unitNameSearch,
                            searchSubCategory,
                            searchStatus
                          )
                        }
                      >
                        District{" "}
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th className="ad-long unit-name-filter">
                        <div className="d-flex justify-content-between align-items-center">
                          <span>Unit Name</span>
                          <i
                            className="fa fa-filter cursor-pointer text-white"
                            style={{ fontSize: "12px" }}
                            onClick={(e) => {
                              e.stopPropagation(); // prevent sorting
                              setShowUnitFilter(!showUnitFilter);
                              setUnitNameSearch("");
                              getApplicationTableData(
                                sortBy,
                                currentPage + 1,
                                orderBy,
                                searchData,
                                "",
                                searchSubCategory,
                                searchStatus
                              );
                            }}
                          ></i>
                        </div>

                        {showUnitFilter && (
                          <div className="mt-1">
                            <input
                              type="text"
                              autoFocus
                              className="form-control form-control-sm"
                              placeholder="Search..."
                              style={{
                                fontSize: "12px",
                                height: "28px",
                                padding: "2px 6px",
                                width: "100%",
                              }}
                              value={unitNameSearch || ""}
                              onChange={(e) =>
                                handleUnitNameFilter(e.target.value)
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                        )}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          getApplicationTableData(
                            "username",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            unitNameSearch,
                            searchSubCategory,
                            searchStatus
                          )
                        }
                      >
                        Customer Name{" "}
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          getApplicationTableData(
                            "tracking_number",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            unitNameSearch,
                            searchSubCategory,
                            searchStatus
                          )
                        }
                      >
                        Tracking Number{" "}
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          getApplicationTableData(
                            "customer_id",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            unitNameSearch,
                            searchSubCategory,
                            searchStatus
                          )
                        }
                      >
                        Customer Id{" "}
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>
                      </th>
                      {appStatus === "" ||
                        (!appStatus && <th className="ad-long">User</th>)}
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          getApplicationTableData(
                            "updated_at",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            unitNameSearch,
                            searchSubCategory,
                            searchStatus
                          )
                        }
                      >
                        Last Updated{" "}
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>
                      </th>
                      <th className="ad-long">Status</th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) => 
                          getApplicationTableData(
                            "flag_count",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            unitNameSearch,
                            searchSubCategory,
                            searchStatus
                          )}
                      >
                        Flag Count{" "}
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {applicationList?.length > 0 ? (
                      applicationList.map((item, index) => {
                        const rowBgColor = getRowBgColor(item?.earliest_log_created_at, item?.status);
                        const rowTextClass = getTextColor(item?.earliest_log_created_at, item?.status);
                        return (
                          <tr
                            key={index}
                            className={index % 2 != 0 ? "adm-even" : ""} style={{ backgroundColor: rowBgColor }}
                          >
                            <td className={rowTextClass}>{currentPage * 10 + (index + 1)}</td>
                            <td className={rowTextClass}>
                              {item?.sub_category_name
                                ? item?.sub_category_name
                                : "--"}
                            </td>
                            <td className={rowTextClass}>
                              {item?.district_name ? item?.district_name : "--"}
                            </td>
                            <td className={rowTextClass}>
                              {item?.accommodation_val
                                ? item?.accommodation_val
                                : "--"}
                            </td>
                            <td className={rowTextClass}>{item?.username ? item?.username : "--"}</td>
                            <td className={rowTextClass}>
                              {item?.tracking_number
                                ? item?.tracking_number
                                : "--"}
                            </td>
                            <td className={rowTextClass}>
                              {item?.customer_id ? item?.customer_id : "--"}
                            </td>
                            <td className={rowTextClass}>
                              {item?.updated_at
                                ? formatDateWithSlash(item?.updated_at)
                                : "--"}
                            </td>
                            <td className={rowTextClass}>
                              {item?.status
                                ? applicationStatusList?.find(
                                    (option) => option.value == item?.status
                                  )?.label
                                : "--"}
                            </td>
                            <td className={rowTextClass}>
                                {item?.flag_count ? item?.flag_count : "0"}
                            </td>
                          </tr>
                        );
                      })
                    ) : tableDataLoaded ? (
                      <NotFoundTable colSpan="12" />
                    ) : null}
                  </tbody>
                </Table>
                {totalPages > 1 && applicationList?.length > 0 && (
                  <div className="d-flex w-100 justify-content-end">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={totalPages} // Total number of pages from API
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={1}
                      onPageChange={handlePageChange} // Method to handle page click
                      forcePage={currentPage}
                      containerClassName={"pagination justify-content-center"} // Custom CSS classes
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={`page-item${
                        !applicationList?.length > 0 ? " disabled" : ""
                      }`}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminDashboard>
  );
};

export default CategoriesApplicationReport;
